import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const data = [
  { name: "Completed", value: 80 },
  { name: "Cancelled", value: 20 },
];

const COLORS = ["#1970E6", "#E41B1B", ];

const CompletedVsCancelled = () => {
  return (
      <ResponsiveContainer width="100%" height={175}>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={80}
            innerRadius={30}
            fill="#8884d8"
            label={({ name }) => `${name}`} 
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={COLORS[index % COLORS.length]}
              />
            ))}
          </Pie>
          <Tooltip
            formatter={(value) => `${value}`}
            labelFormatter={(label) => `${label}`}
          />
        </PieChart>
      </ResponsiveContainer>
  );
};

export default CompletedVsCancelled;
